import { render } from "./PetFiles.vue?vue&type=template&id=cf2e9662&scoped=true"
import script from "./PetFiles.vue?vue&type=script&lang=js"
export * from "./PetFiles.vue?vue&type=script&lang=js"

import "./PetFiles.vue?vue&type=style&index=0&id=cf2e9662&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2e9662"]])

export default __exports__